module.exports = __webpack_public_path__ + "static/media/bicycles_hero_mobile.acafe81f.jpg";